// extracted by mini-css-extract-plugin
export default {"primaryColor":"#fbaa01","primaryTextColor":"#15104d","secondaryTextColor":"#7d8fb3"};